/* Imports */
import React from 'react'

/* Functional Component */
function Line() {
  return (
    <div className='w-[1px] h-4 bg-darkPurple mx-3'></div>
  )
}

/* Exports */
export default Line